export default "__VITE_ASSET__lXoiTGsz__"